<template>
  <div class="search-term-keyword-input">
    <div class="row">
      <div class="columns">
        <div class="row">
          <ElFormItem
            :rules="keywordRules.query"
            class="columns small-8"
            :prop="queryProp"
          >
            <AddKeywordInput
              :matching-type="matchingType"
              :query="query"
              name="query"
              required
              :show-match-type-description="false"
              @update:matchingType="updateMatchingType"
              @update:query="updateQuery"
            />
            <InputHelper v-if="error" el-icon="el-icon-warning" type="alert">
              {{ error }}
            </InputHelper>
          </ElFormItem>
          <ElFormItem
            :rules="keywordRules.priceOffer"
            class="columns small-4"
            :prop="priceOfferProp"
          >
            <ElInput
              :value="priceOffer"
              type="number"
              name="priceOffer"
              step="100"
              required
              @input="updatePriceOffer"
            />
          </ElFormItem>
        </div>
        <hr class="search-term-keyword-input__divider is-collapse-child" />
      </div>
    </div>
  </div>
</template>

<script>
import AddKeywordInput from '@@/advertisement/common/AddKeywordInput';

import InputHelper from '@@/common/InputHelper';

import required from '@/utils/validation-rules/required';

export default {
  name: 'SearchTermsKeywordInput',
  components: { AddKeywordInput, InputHelper },
  props: {
    matchingType: {
      type: String,
      required: true,
    },
    query: {
      type: String,
      required: true,
    },
    priceOffer: {
      type: Number,
      required: true,
    },
    queryProp: {
      type: String,
      default: 'query',
    },
    priceOfferProp: {
      type: String,
      default: 'priceOffer',
    },
    error: {
      type: String,
      default: '',
    },
  },
  computed: {
    keywordRules() {
      const requiredRule = required(this.$t('VALIDATION_REQUIRED_ERR'));
      return {
        query: requiredRule,
        priceOffer: requiredRule,
      };
    },
  },
  methods: {
    updateMatchingType(value) {
      this.$emit('update:matchingType', value);
    },
    updateQuery(value) {
      this.$emit('update:query', value);
    },
    updatePriceOffer(value) {
      this.$emit('update:priceOffer', Number(value));
    },
  },
};
</script>

<style lang="scss">
.search-term-keyword-input {
  &__divider {
    margin: 1rem 0 0;
    border: 1px dashed $lb-light-gray;
  }
}
</style>
